module.exports = {
  home: {
    key: 'home',
    label: 'Home',
  },
  work: {
    key: 'work',
    label: 'Work',
  },
  temp: {
    key: 'temp',
    label: 'Temp',
  },
  old: {
    key: 'old',
    label: 'Old',
  },
  mobile: {
    key: 'mobile',
    label: 'Mobile',
  },
};